import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@vds-core/utilities';
import { Image } from '@vds-core/images';
var propTypes = {
  /**
   * Alternative text for the image.
   */
  alt: PropTypes.string,

  /**
   * ARIA label of the Image Wrapper
   */
  ariaLabel: PropTypes.string,

  /**
   * An array of image data
   * or a single string url
   */
  // src: PropTypes.arrayOf(PropTypes.object({
  //   srcset: PropTypes.string,
  //   type: PropTypes.string, // MIME type for image
  //   maxViewport: PropTypes.oneOf(['mobile', 'tablet', 'desktop'])
  // })),
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

  /**
   * Options for image wrapper dimension
   * Defaults to 72x72
   */
  size: PropTypes.oneOf(['72', '116'])
};
var defaultProps = {
  size: '72'
};
var ImageWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ImageWrapper",
  componentId: "VDS__sc-1ymgtoo-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-width: ", "px;\n  width: 100%;\n  overflow: hidden;\n  border-radius: ", ";\n"])), function (_ref) {
  var maxWidth = _ref.maxWidth;
  return maxWidth;
}, calculateRem(4));

var ListGroupItemImage = function ListGroupItemImage(props) {
  var size = props.size,
      src = props.src,
      alt = props.alt,
      ariaLabel = props.ariaLabel; // Used to determine to map src to url prop or sources prop

  var isSrcArray = Array.isArray(src);
  return /*#__PURE__*/React.createElement(ImageWrapper, {
    maxWidth: size
  }, /*#__PURE__*/React.createElement(Image, _extends({}, isSrcArray ? {
    sources: src
  } : {
    url: src
  }, {
    hasAspectRatio: true,
    constrainToWidth: true,
    alt: alt,
    ariaLabel: ariaLabel,
    role: "img",
    ratio: "1:1"
  })));
};

ListGroupItemImage.propTypes = propTypes;
ListGroupItemImage.defaultProps = defaultProps;
ListGroupItemImage.displayName = 'ListGroupItemImage';
export default ListGroupItemImage;